import Coral from "../styles/img/Coral.jpg"
import Sea from "../styles/img/Sea.jpg"
import Culture from "../styles/img/Culture.jpg"
function RedSeaIslandTimeLine() {
  return (
    <>
      <section className="page-section" id="about">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2 className="section-heading text-uppercase" style={{ color: "#908960" }}>
                TIMELINE
              </h2>
              <h3 className="section-subheading text-muted">
                The unprecedented scales of planning and construction of The Red Sea Project mean that the development
                is constantly moving forwards.
              </h3>
            </div>
          </div>
          <div
            className="row"
            style={{ border: "solid #908960", borderRadius: "20%", backgroundColor: "#908960", color: "#F0F4C3" }}
          >
            <br />
            <div className="col-lg-12">
              <ul className="timeline">
                <li>
                  <div className="timeline-image">
                    <img
                      className="rounded-circle img-fluid"
                      src="https://www.theredsea.sa/-/media/images/timeline/31-july-17.jpg?cx=0&cy=0&cw=225&ch=225&hash=6441A231E34186B67B15D4EC4BC9691C"
                      alt="timeline-img-1"
                    />
                  </div>
                  <div className="timeline-panel">
                    <div className="timeline-heading">
                      <h4>31 Jul 2017</h4>
                    </div>
                    <div className="timeline-body">
                      <p>
                        His Royal Highness the Crown Prince Announces the Launch of ‘The Red Sea’ project as an
                        international tourist destination as part of the Kingdom’s 2030 Vision{" "}
                      </p>
                    </div>
                  </div>
                </li>
                <li className="timeline-inverted">
                  <div className="timeline-image">
                    <img
                      alt="timeline-img-2"
                      className="rounded-circle img-fluid"
                      src="https://www.theredsea.sa/-/media/images/timeline/22-jan-19.jpg?cx=0&cy=0&cw=225&ch=225&hash=36858D705564E173F65BB9462642B468"
                    />
                  </div>
                  <div className="timeline-panel">
                    <div className="timeline-heading">
                      <h4>22 Jan 2019</h4>
                    </div>
                    <div className="timeline-body">
                      <p>Red Sea Project Master Plan wins seal of approval from the Board of Directors. </p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="timeline-image">
                    <img
                      alt="timeline-img-3"
                      className="rounded-circle img-fluid"
                      src="https://www.theredsea.sa/-/media/images/timeline/27-feb-19.jpg?cx=0&cy=0&cw=225&ch=225&hash=4D11FF01AD07F4D5E6AFD78E70D6A551"
                    />
                  </div>
                  <div className="timeline-panel">
                    <div className="timeline-heading">
                      <h4>27 Feb 2019</h4>
                    </div>
                    <div className="timeline-body">
                      <p>
                        Construction underway on The Red Sea Project Site. Base Camp kicks off the enabling works which
                        will oversee construction of essential infrastructure for the development.
                      </p>
                    </div>
                  </div>
                </li>
                <li className="timeline-inverted">
                  <div className="timeline-image">
                    <img
                      alt="timeline-img-4"
                      className="rounded-circle img-fluid"
                      src="https://www.theredsea.sa/-/media/images/timeline/6-june-19.jpg?cx=0&cy=0&cw=225&ch=225&hash=BB22D7894B2134BB5E0FCAB4920CBD18"
                    />
                  </div>
                  <div className="timeline-panel">
                    <div className="timeline-heading">
                      <h4>06 Jun 2019</h4>
                    </div>
                    <div className="timeline-body">
                      <p>The Red Sea Development Company and KAUST launch the Brains for Brine Challenge</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="timeline-image">
                    <img
                      alt="timeline-img-5"
                      className="rounded-circle img-fluid"
                      src="https://www.theredsea.sa/-/media/images/timeline/24-oct-19.jpg?cx=0&cy=0&cw=225&ch=225&hash=9BCF42789A37C3AD61D229846EF3366E"
                    />
                  </div>
                  <div className="timeline-panel">
                    <div className="timeline-heading">
                      <h4>24 Oct 2019</h4>
                    </div>
                    <div className="timeline-body">
                      <p>The Red Sea Development Company to begin filming time lapse footage of new destination</p>
                    </div>
                  </div>
                </li>
                <li className="timeline-inverted">
                  <div className="timeline-image">
                    <img
                      alt="timeline-img-6"
                      className="rounded-circle img-fluid"
                      src="https://www.theredsea.sa/-/media/images/timeline/30-oct-19.jpg?cx=0&cy=0&cw=225&ch=225&hash=F21E0C4934549AA0A343875F82FF9A27"
                    />
                  </div>
                  <div className="timeline-panel">
                    <div className="timeline-heading">
                      <h4>30 Oct 2019</h4>
                    </div>
                    <div className="timeline-body">
                      <p>The Red Sea Development Company Awards Contract for Destination’s International Airport</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="timeline-image">
                    <img
                      alt="timeline-img-7"
                      className="rounded-circle img-fluid"
                      src="https://www.theredsea.sa/-/media/images/timeline/29-apr-20.png?cx=0&cy=0&cw=225&ch=225&hash=A5BE53D9BE681EE53A6BFAB866F3D767"
                    />
                  </div>
                  <div className="timeline-panel">
                    <div className="timeline-heading">
                      <h4>29 Apr 2020</h4>
                    </div>
                    <div className="timeline-body">
                      <p>The Red Sea Development Company Identifies Optimum Location of Overwater Assets</p>
                    </div>
                  </div>
                </li>
                <li className="timeline-inverted">
                  <div className="timeline-image">
                    <img
                      alt="timeline-img-8"
                      className="rounded-circle img-fluid"
                      src="https://www.theredsea.sa/-/media/images/timeline/27-july-20.png?cx=0&cy=0&cw=225&ch=225&hash=263A90B5603FC3DDE88CBAC048098BD6"
                    />
                  </div>
                  <div className="timeline-panel">
                    <div className="timeline-heading">
                      <h4>27 Jul 2020</h4>
                    </div>
                    <div className="timeline-body">
                      <p>
                        The Red Sea Development Company Announces ‘Ecotecture” Design Competition for Destination’s
                        Coastal Village
                      </p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="timeline-image">
                    <img
                      alt="timeline-img-9"
                      className="rounded-circle img-fluid"
                      src="https://www.theredsea.sa/-/media/images/timeline/28-jan-21.png?cx=0&cy=0&cw=225&ch=225&hash=314EBBFD519FADF10C6CE6CC686DC8EE"
                    />
                  </div>
                  <div className="timeline-panel">
                    <div className="timeline-heading">
                      <h4>28 Jan 2021</h4>
                    </div>
                    <div className="timeline-body">
                      <p>
                        The Red Sea Project becomes first development in Middle East to secure first stage of LEED
                        platinum certification for destination’s plans and designs
                      </p>
                    </div>
                  </div>
                </li>
                <li className="timeline-inverted">
                  <div className="timeline-image">
                    <img
                      alt="timeline-img-10"
                      className="rounded-circle img-fluid"
                      src="https://www.theredsea.sa/-/media/images/timeline/24-feb-21.png?cx=0&cy=0&cw=225&ch=225&hash=C807A6BA62B1A7020609286C8CE94C32"
                    />
                  </div>
                  <div className="timeline-panel">
                    <div className="timeline-heading">
                      <h4>24 Feb 2021</h4>
                    </div>
                    <div className="timeline-body">
                      <p>
                        The Red Sea Development Company appoints Gartner for flagship destination’s technology
                        procurement advisory services
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="page-section" style={{ backgroundColor: "#908960", color: "#F0F4C3" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2 className="section-heading text-uppercase">DESTINATION</h2>
              <br /> <br />
            </div>
          </div>
          <div className="container row">
            <div className="col-sm-4">
              <div className="team-member">
                <img className="mx-auto rounded-circle" src={Coral} alt="coral-img" />
                <h4>NATURE</h4>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="team-member">
                <img className="mx-auto rounded-circle" src={Sea} alt="sea-img" />
                <h4>ISLAND</h4>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="team-member">
                <img className="mx-auto rounded-circle" src={Culture} alt="culture-img" />
                <h4>CULTURE</h4>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
export default RedSeaIslandTimeLine
